import view, * as fromView from './view';
import compareOpen, * as fromCompareOpen from './compareOpen';
import trendIds, * as fromTrendIds from './trendIds';
import compareTrend, * as fromCompareTrend from './compareTrend';
import shared, * as fromShared from './shared';
import compareForm, * as fromCompareForm from './compareForm';
import trendCount, * as fromTrendCount from './trendCount';
import isLoading, * as fromIsLoading from './isLoading';
import { combineReducers } from 'redux';
import { CHART_TYPE, LOADING } from '../../../utils/constants';

export default combineReducers({
  view,
  compareOpen,
  trendIds,
  compareTrend,
  compareForm,
  trendCount,
  shared: combineReducers({
    [CHART_TYPE.MAIN]: shared(CHART_TYPE.MAIN),
    [CHART_TYPE.COMPARE]: shared(CHART_TYPE.COMPARE)
  }),
  isLoading: combineReducers({
    [CHART_TYPE.MAIN]: isLoading(CHART_TYPE.MAIN),
    [CHART_TYPE.COMPARE]: isLoading(CHART_TYPE.COMPARE),
    [LOADING.TRENDS]: isLoading(LOADING.TRENDS)
  })
});

export const getView = state => fromView.getView(state.view);
export const getSelected = (state, chartType, selectionType) => fromShared.getSelected(state.shared[chartType], selectionType);
export const getQuickRange = (state, chartType) => fromShared.getQuickRange(state.shared[chartType]);
export const getFromDate = (state, chartType) => fromShared.getFromDate(state.shared[chartType]);
export const getToDate = (state, chartType) => fromShared.getToDate(state.shared[chartType]);
export const getGroup = (state, chartType) => fromShared.getGroup(state.shared[chartType]);
export const getHoverLine = (state, chartType) => fromShared.getHoverLine(state.shared[chartType]);
export const getBrushStartTimestamp = (state, chartType) => fromShared.getBrushStartTimestamp(state.shared[chartType]);
export const getBrushEndTimestamp = (state, chartType) => fromShared.getBrushEndTimestamp(state.shared[chartType]);
export const getCopiedText = (state, chartType) => fromShared.getCopiedText(state.shared[chartType]);
export const getEditingFunction = (state, chartType) => fromShared.getEditingFunction(state.shared[chartType]);
export const getFunctionDescriptionEditText = (state, chartType) => fromShared.getFunctionDescriptionEditText(state.shared[chartType]);
export const getFeaturesToggle = (state, chartType) => fromShared.getFeaturesToggle(state.shared[chartType]);
export const getSelectedFeature = (state, chartType) => fromShared.getSelectedFeature(state.shared[chartType]);
export const getFeatureWindow = (state, chartType) => fromShared.getFeatureWindow(state.shared[chartType]);
export const getSelectedProperty = (state, chartType) => fromShared.getSelectedProperty(state.shared[chartType]);
export const getExpandTrendTimeline = (state, chartType) => fromShared.getExpandTrendTimeline(state.shared[chartType]);
export const getCompareOpen = state => fromCompareOpen.getCompareOpen(state.compareOpen);
export const getTrendIds = state => fromTrendIds.getTrendIds(state.trendIds);
export const getCompareTrend = state => fromCompareTrend.getCompareTrend(state.compareTrend);
export const getCompareAll = state => fromCompareForm.getAll(state.compareForm);
export const getCompareFromDate = state => fromCompareForm.getFromDate(state.compareForm);
export const getCompareToDate = state => fromCompareForm.getToDate(state.compareForm);
export const getCompareLabels = state => fromCompareForm.getLabels(state.compareForm);
export const getTrendCount = state => fromTrendCount.getTrendCount(state.trendCount);
export const getIsLoading = (state, namespace) => fromIsLoading.getIsLoading(state.isLoading[namespace]);